import type { CSSProperties } from 'react'

/**
 * The replay's chrome is dark in both app themes.
 *
 * It is a full-bleed map, and a light bar over aerial imagery washes out the
 * terrain it is meant to sit beside. These are literal colours rather than theme
 * tokens for that reason: they must not follow the light theme.
 */
export const REPLAY_CHROME = {
  /** The surface behind the map, visible only before tiles arrive. */
  background: '#0f1110',
  topBarBackground: 'rgba(15,17,16,0.92)',
  barBackground: 'rgba(15,17,16,0.94)',
  hairline: 'rgba(255,255,255,0.08)',
  trackBackground: 'rgba(255,255,255,0.22)',
  /** Secondary text on the dark chrome. */
  mutedText: 'rgba(255,255,255,0.6)',

  /** A translucent control on the dark chrome — chips and icon buttons. */
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.1)',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.25)',
    borderRadius: 8,
    padding: '6px 10px',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  } satisfies CSSProperties,

  iconButton: {
    width: 34,
    height: 34,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderRadius: 8,
    background: 'rgba(255,255,255,0.1)',
    color: '#fff',
    cursor: 'pointer',
    flexShrink: 0,
  } satisfies CSSProperties,
} as const
